import '../global.css'
import AuthProvider, { useAuth } from "../context/AuthContext";
import Signup from "./Signup";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import Signin from "./Signin";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "./ForgotPassword";
import Home from "./pages/Home";
import { Container100, MoContainer, MoSpan, MoLink } from "../Mo7/mo7UI";
import Test from "./Test"
import { cols } from '../services/design.sevice';
import AnnouncementProfile from './pages/AnnouncementProfile';
import AboutUs from './pages/AboutUs';
import TutoBoltDataProvider from "../context/TutorBoltDataContext"
import Lottie from 'react-lottie'
import animationData from '../lotties/404_page'

function App() {

  return (
    <Container100>
      <Router>
        <AuthProvider>
          <TutoBoltDataProvider>
            <Switch>
              {/* Profile */}
              <PrivateRoute path="/dashboard" component={Dashboard} />

              {/* public */}
              <Route path="/home" component={Home} />
              <Route path="/about-us" component={AboutUs} />
              <PrivateRoute path="/announcement/:announcement_id" component={AnnouncementProfile} />

              {/* Athentication */}
              <Route path="/signup" component={Signup} />
              <Route path="/signin" component={Signin} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/test" component={Test} />
              <Route component={NotFound} />

            </Switch>
          </TutoBoltDataProvider>
        </AuthProvider>
      </Router>

    </Container100>
  );
}

export default App;

export function NotFound() {
  const { currentUser } = useAuth()
  const lottieDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  }

  return <MoContainer bg={cols.mainLight_1} w="100vw" h="100vh" pos="relative">
    {/* <MoContainer trfm='translate(50% ,50%)' pos="absolute" tr w="50%" h="50%" bg_i={icons.img_404} bg_i_s="contain" z="1" /> */}
    <MoContainer pos="absolute" trfm='translate(30.5vw ,5%)'>
      <Lottie options={lottieDefaultOptions}
        width={500}
        isStopped={false} />
    </MoContainer>
    <MoContainer grid place="center" pd={{ tb: "1rem", lr: "0" }} w="100%">
      <MoSpan > Oops ,This Page Does't Exist 😕 </MoSpan>
    </MoContainer>
    <MoContainer grid place="center" pos="absolute" pos_dir={{ b: "2rem" }} pd={{ tb: "1rem", lr: "0" }} w="100%">
      <MoLink to={currentUser ? "/dashboard/home" : "/home"}> <MoSpan fs_mid f_w='600'> {currentUser ? "My Dashboard " : "Go Home"} 😅</MoSpan> </MoLink>
    </MoContainer>
  </MoContainer>
}
